import React, { useEffect, useState } from "react";
import * as moment from "moment";
import { Button, Card, Form, Col, Row, Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { deleteJob, getJobs } from "../../../../services/JobService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
  Filter,
} from "react-bs-datatable";
import "../Pagination.css";

const JobList = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [filterText, setFilterText] = useState("");

  // Fetch jobs data from service
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const jobsData = await getJobs();
        setJobs(jobsData);
      } catch (error) {
        console.error("Error fetching jobs", error);
      }
    };
    fetchJobs();
  }, []);

  // Handle view and delete actions
  const onView = (id) => navigate("/settings/jha-setting/view", { state: { id: id } });
  const onDelete = async (id) => {
    try {
      await deleteJob(id);
      setJobs(jobs.filter((j) => j._id !== id));
    } catch (error) {
      console.error(`Error deleting job with id ${id}`, error);
    }
  };

  // Table header configuration for Datatable
  const header = [
    { prop: "sr", title: "SR" },
    { prop: "jobTitle", title: "Job Title" },
    { prop: "ppe", title: "PPE" },
    { prop: "createdAt", title: "Date", cell: (row) => moment(row.createdAt).format("MM-DD-YYYY") },
    { prop: "status", title: "Status", cell: (row) => (
      <div className="d-flex align-items-center" style={{ textTransform: "uppercase" }}>
        <i className={`fa fa-circle text-${row.status === 'active' ? 'success' : 'danger'} me-1`} />
        {row.status}
      </div>
    )},
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <div className="d-flex">
          <Button onClick={() => onView(row._id)} title="View" className="btn btn-primary shadow btn-xs sharp me-1">
            <i className="fa fa-eye"></i>
          </Button>
          <Button onClick={() => onDelete(row._id)} title="Delete" className="btn btn-danger shadow btn-xs sharp">
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  // Prepare the data for the datatable
  const tableData = jobs.map((job, index) => ({
    sr: index + 1,
    jobTitle: job.jobTitle,
    ppe: job.ppe,
    createdAt: job.createdAt,
    status: job.status,
    _id: job._id, // Needed for actions
  }));
  const filteredData = tableData.filter((item) =>
    item.jobTitle.toString().toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div>
      <Card>
        <Card.Body >
          <Row className="mb-4">
            <Col xs={12} lg={4}>
              <Form.Control
                type="text"
                placeholder="Search by Job Title"
                className="mb-3"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
          </Row>

          {/* Datatable Wrapper */}
          <DatatableWrapper 
            body={filteredData}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15],
              },
            }}
          >
            <Row className="mb-4">
            
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
          </Row>

          <Table >
            
            <TableHeader />
            <TableBody />
            
          </Table>

            {/* Pagination Footer */}
            <Row>
              <Col className="d-flex flex-col justify-content-start">
                <PaginationOptions />
              </Col>
              
              <Col className="d-flex justify-content-end mt-4">
                <Pagination />
              </Col>
            </Row>
          </DatatableWrapper>
        </Card.Body>
      </Card>
    </div>
  );
};

export default JobList;
